import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.$label = this.$('label')[0];
        this.labelOffset = 60;


    }

    init() {

        this.blockMobile = this.getData('mobile') == 'block';
        this.$label.style.width = `auto`;
        this.baseWidth = this.$label.getBoundingClientRect().width;

        gsap.delayedCall(window.readyDelayCallback,() => {
            this.resize();
        });

        // this.bindResize = this.resize.bind(this);
        // window.addEventListener('resize', this.bindResize);

    }

    resize() {
        if(this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        
        this.el.classList.remove('is-ready');

        this.resizeTimeout = gsap.delayedCall(0.2, () => {
            this.resizeDebounce();
        });
        
    }

    resizeDebounce() {
        this.$label.style.width = `auto`;

        this.resizeTimeout = gsap.delayedCall(0.15, () => {
            this.baseWidth = this.$label.getBoundingClientRect().width;

            let newWidth = this.baseWidth + this.labelOffset;

            if(this.blockMobile && window.innerWidth < 1024) {
                newWidth = this.baseWidth;
            }

            this.el.classList.add('is-ready');

            this.resizeTimeout = gsap.delayedCall(0.1, () => {
                
                this.$label.style.width = `${newWidth}px`;

                this.el.style.setProperty('--label-translate-negative', `${- newWidth}px`);
                this.el.style.setProperty('--label-translate', `${newWidth}px`);
            });
        });
    }
    
    destroy() {
        window.removeEventListener('resize', this.bindResize);
    }
}
